import $ from 'jquery';
import axios from 'axios';

declare var ASPxClientControl: any;

export default class NavControllerTs {
    NavigateToPath = (url: string) => {
        axios
            .get(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
            .then(response => {
                $('#claritycontentpanel').html(response.data);
            });
    };

    PinToNavBar = (recordId: number, url: string, parentItemName: string, itemDisplayText: string, toolTip: string) => {
        axios
            .post('/Home/AddSelectedItem', {
                recordId,
                url,
                parentItemName,
                itemDisplayText,
                toolTip,
            })
            .then(result => {
                if (!result.data.success) {
                    alert(result.data.error);
                } else {
                    const menuPanel = ASPxClientControl.GetControlCollection().GetByName('clarityLeftMenuPanel');
                    menuPanel.PerformCallback('', () => {
                        document.querySelectorAll('#clarityLeftMenu li').forEach(el => {
                            el.classList.remove('selectedItem');
                            el.classList.remove('dxnb-itemSelected');
                        });

                        const parent = document.querySelector('#clarityLeftMenu a[href="' + result.data.fullUrlPath + '"]').parentElement;
                        parent.classList.add('selectedItem');
                    });
                }
            })
            .catch(error => {
                alert(error);
            });
    };
}
